import { combineReducers } from 'redux';
import mainReducerData from './MainReducers';
import LoginReducer from '../GlobalModules/Login/Reducers/LoginReducer';
//import HomeReducer from '../Home/Reducers/HomeReducer';
export default combineReducers({
    mainReducerData,
    LoginReducer,
   // HomeReducer
})